import { forwardRef, ReactElement } from 'react';
import { Dialog, Zoom } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { makeStyles } from 'tss-react/mui';
import { SupportUsBanner } from 'components/SupportUsBanner';
import { useSearchDrawerState } from 'state/useSearchDrawerState';
import { useMapEntityDrawerState } from 'features/mapping/hooks/useMapEntityDrawerState';
import { getMapDialogCommonStyles } from 'features/mapping/mapping.utils';
import { MAP_DOM_ELEMENT_ID } from '../../../../../constants';
import { useSupportUsDialog } from './useSupportUsDialog';

const useStyles = makeStyles<{
  isDrawerEntitySelected: boolean;
  isSearchDrawerOpen: boolean;
  minSnapPct: number;
}>()((theme, { isDrawerEntitySelected, isSearchDrawerOpen, minSnapPct }) => {
  const styles = getMapDialogCommonStyles(theme, {
    isDrawerEntitySelected,
    isSearchDrawerOpen,
    minWidth: 343,
    minSnapPct,
  });

  return {
    ...styles,
    paper: {
      ...styles.paper,
      borderRadius: '16px',
    },
  };
});

const Transition = forwardRef(
  (props: TransitionProps & { children: ReactElement }, ref) => {
    return (
      <Zoom
        ref={ref}
        {...props}
        timeout={250}
        style={{ transitionDelay: '2500ms' }}
      />
    );
  },
);

Transition.displayName = 'Transition';

export const SupportUsDialog = (): JSX.Element => {
  const { open: isSearchDrawerOpen } = useSearchDrawerState();
  const { open: isDrawerEntitySelected, minSnapPct } =
    useMapEntityDrawerState();
  const { classes } = useStyles({
    isDrawerEntitySelected,
    isSearchDrawerOpen,
    minSnapPct,
  });
  const { open, handleClose } = useSupportUsDialog();

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        root: classes.root,
        container: classes.container,
        paper: classes.paper,
      }}
      hideBackdrop
      container={(): HTMLElement | null =>
        document.getElementById(MAP_DOM_ELEMENT_ID)
      }
      slots={{ transition: Transition }}
    >
      <SupportUsBanner onClose={handleClose} />
    </Dialog>
  );
};
